import React, { ReactElement, useEffect } from 'react';
import { Space } from 'antd';

import { BreadcrumbItem } from 'types';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import StartContract from 'pricing/components/contract/startContract/StartContract';
import CancelContract from 'pricing/components/contract/cancelContract/CancelContract';
import ContractForm from 'pricing/components/contract/contractForm/ContractForm';
import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { PricingLayoutPageHeaderStyled } from 'pricing/components/layout/PricingLayout.styles';
import { PricingRoutes } from 'pricing/types';
import { testId } from 'pricing/utilities/test/dataTestId';

const breadcrumbs: BreadcrumbItem[] = [
  {
    key: 'main',
    label: 'Main',
    path: '/',
  },
  {
    key: 'pricing',
    label: 'Pricing',
  },
  {
    key: 'contractCreate',
    label: 'Contracts',
    path: PricingRoutes.ContractList,
  },
  {
    key: 'contractCreate',
    label: 'Create Contract',
  },
];

function ContractCreateContent(): ReactElement {
  const { dispatch: dispatchLayout } = useLayoutState();
  const { dispatch } = useContractState();

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
    dispatch({ type: 'SET_CONTRACT_MODE', contractMode: 'create' });
  }, []);

  return (
    <main data-testid={testId.pricingPageContractCreate}>
      <section data-testid={testId.pricingLayoutPageHeader}>
        <PricingLayoutPageHeaderStyled
          title="Upload New Contract"
          extra={
            <Space>
              <CancelContract />
              <StartContract />
            </Space>
          }
        />
      </section>
      <ContractForm />
    </main>
  );
}

export default ContractCreateContent;
